import React from 'react';
import classes from './AirlineLogo.scss';

const airlineLogo = (props) => {
    const airlineCode = props.airlineCode;
    return window.innerWidth <= 600 ? <i className={`intAirLogo size-18 x${airlineCode} ${classes.Image}`}></i> : <i className={`intAirLogo size-28 x${airlineCode} ${classes.Image}`}></i>
}

export default airlineLogo;


// WEBPACK FOOTER //
// ./src/components/Flight/Airline/AirlineLogo/AirlineLogo.js